import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'catrus-theme';

/**
 * Хук переключения темы CatRUS.
 * Поддерживает три режима: 'light', 'dark', 'system'.
 * Эффективная тема (то что реально применяется) хранится в data-theme на <html>.
 */
export function useTheme() {
  const [mode, setMode] = useState(() => localStorage.getItem(STORAGE_KEY) || 'dark');

  const apply = useCallback((m) => {
    const effective = m === 'system'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : m;
    document.documentElement.setAttribute('data-theme', effective);
    localStorage.setItem(STORAGE_KEY, m);
    setMode(m);
  }, []);

  useEffect(() => {
    apply(mode);
    // Подписка на изменение системной темы
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => { if (localStorage.getItem(STORAGE_KEY) === 'system') apply('system'); };
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { mode, setMode: apply };
}
